export default __webpack_public_path__ + "static/media/file_type_custom.f822d8f5.svg";